module.exports = __webpack_public_path__ + "img/95.1b315364.jpg";